import { upperCase } from 'lodash';

export const GRAPHQL_URI = '/graphql';
export const API_GRAPHQL_URI = '/api/graphql';

/**
 * KU – performs a graphql query against the /graphql endpoint. This method
 * should only be called if user is logged in since authentication is required
 * for access.
 *
 */
const performQuery = (query: string, endpoint: string = GRAPHQL_URI) =>
  fetch(endpoint, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({ query }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const performAssignExperimentMutation = (name: string) =>
  performQuery(`
    mutation {
      assignExperiment(name: "${name}") {
        preferences {
          name
          value
        }
      }
    }
  `);

export const performEnrollInFASTPlan = () =>
  performQuery(
    `
    mutation enrollInFastPlan {
      enrollInFastPlan {
        fastPlanState
      }
    }
  `,
    API_GRAPHQL_URI,
  );

export const performCreateUnauthenticatedFASTAccountToAsset = (
  assetId: string,
  deviceType: string,
  deviceIdent: string,
) =>
  performQuery(
    `
        mutation ensureAccessToFastAsset {
          ensureAccessToFastAsset(assetId: "${assetId}", device: {
            type: ${upperCase(deviceType)},
            ident: "${deviceIdent}"
          }) {
            asset {
              fastAccess
              playableUniversalURL
            }
            createdUncredentialedUser
            user {
              analyticsId
              displayName
              hasFastAccess
              isUncredentialed
            }
          }
        }
      `,
    API_GRAPHQL_URI,
  );

export const performCreateUnauthenticatedFASTAccount = (deviceType: string, deviceIdent: string) =>
  performQuery(
    `
      mutation createFastUncredentialedUser {
        createFastUncredentialedUser(device: {
          type: ${upperCase(deviceType)},
          ident: "${deviceIdent}"
        }) {
          createdUncredentialedUser
          user {
            analyticsId
            displayName
            hasFastAccess
            isUncredentialed
          }
        }
      }
    `,
    API_GRAPHQL_URI,
  );
